import { createComponent } from '@cloudflare/style-container';

var MenuHeader = createComponent(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.colors.gray[3],
    cursor: 'default',
    fontWeight: 'bold',
    fontSize: '.86667rem',
    backgroundColor: theme.colors.gray[9],
    borderBottom: '1px solid ' + theme.colors.gray[8],
    width: '100%',
    '> *': {
      display: 'inline-block',
      padding: '8px 10px'
    }
  };
}, 'h3');
MenuHeader.setDisplayName('MenuHeader');

export default MenuHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-select/es/MenuHeader.js
// module id = 1111
// module chunks = 1